import { Component, HostBinding, Input, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";

@Component({
  selector: "app-page-container-group",
  templateUrl: "./page-container-group.component.html",
  styleUrls: ["./page-container-group.component.scss"],
})
export class PageContainerGroupComponent implements OnInit,OnDestroy {
  constructor() {
    this.paddingLeftSize = "xxxl";
    this.paddingRightSize = "xxxl";
  }
  @Input() noSidePadding = false;
  @HostBinding("class.no-side-padding") get hasNoSidePadding() {
    return this.noSidePadding;
  }
  classObject = {};
  ngOnInit(): void {
  }
  private _paddingLeftSize = "";
  get paddingLeftSize(): string {
    return this._paddingLeftSize;    
  }
  @Input() set paddingLeftSize(paddingLeftSize: string) {
    delete this.classObject[`paddingWrapper--left-${this.paddingLeftSize}`];

    this._paddingLeftSize = paddingLeftSize;
    this.classObject[`paddingWrapper--left-${this.paddingLeftSize}`] = this.paddingLeftSize;
  }

  private _paddingRightSize = "";
  get paddingRightSize(): string {
    return this._paddingRightSize;    
  }
  @Input() set paddingRightSize(paddingRightSize: string) {
    delete this.classObject[`paddingWrapper--right-${this.paddingRightSize}`];

    this._paddingRightSize = paddingRightSize;
    this.classObject[`paddingWrapper--right-${this.paddingRightSize}`] = this.paddingRightSize;
  }
  private _paddingTopSize = "";
  get paddingTopSize(): string {
    return this._paddingTopSize;    
  }
  @Input() set paddingTopSize(paddingTopSize: string) {
    delete this.classObject[`paddingWrapper--top-${this.paddingTopSize}`];

    this._paddingTopSize = paddingTopSize;
    this.classObject[`paddingWrapper--top-${this.paddingTopSize}`] = this.paddingTopSize;
  }
  private _paddingBottomSize = "";
  get paddingBottomSize(): string {
    return this._paddingBottomSize;    
  }
  @Input() set paddingBottomSize(paddingBottomSize: string) {
    delete this.classObject[`paddingWrapper--bottom-${this.paddingBottomSize}`];

    this._paddingBottomSize = paddingBottomSize;
    this.classObject[`paddingWrapper--bottom-${this.paddingBottomSize}`] = this.paddingBottomSize;
  }
  private destroy$ = new Subject<void>();

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
  
}
